import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import formSixteenDownloadApi from '../../../middleware/api/Finance/FormSixteenDownload/FormSixteenDownloadApi'
import {
  downloadFormSixteenFileProps,
  FormSixteenDownloadState,
  getForm16FilesDownResponse,
} from '../../../types/Finance/FormSixteenDownload/FormSixteenDownloadTypes'
import { RootState } from '../../../stateStore'

const downloadFormSixteenFile = createAsyncThunk(
  'formSixteenDownload/getDownForm16File',
  async (data: downloadFormSixteenFileProps, thunkApi) => {
    try {
      return await formSixteenDownloadApi.downloadFormSixteenFile(data)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

export const initialFormSixteenDownloadState: FormSixteenDownloadState = {
  isLoading: ApiLoadingState.idle,
  getForm16FilesDownResponse: {} as getForm16FilesDownResponse,
  getFormSixteenList: [],
  listSize: 0,
}
const formSixteenDownloadSlice = createSlice({
  name: 'formSixteenDownload',
  initialState: initialFormSixteenDownloadState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addMatcher(isAnyOf(downloadFormSixteenFile.fulfilled), (state) => {
        state.isLoading = ApiLoadingState.succeeded
      })
      .addMatcher(isAnyOf(downloadFormSixteenFile.pending), (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addMatcher(isAnyOf(downloadFormSixteenFile.rejected), (state) => {
        state.isLoading = ApiLoadingState.failed
      })
  },
})
const isLoading = (state: RootState): LoadingState =>
  state.formSixteenDownload.isLoading
const getForm16FilesDownload = (state: RootState): getForm16FilesDownResponse =>
  state.formSixteenDownload.getForm16FilesDownResponse

const formSixteenDownloadThunk = {
  downloadFormSixteenFile,
}
const formSixteenDownloadSelectors = {
  isLoading,
  getForm16FilesDownload,
}
export const formSixteenDownloadService = {
  ...formSixteenDownloadThunk,
  actions: formSixteenDownloadSlice.actions,
  selectors: formSixteenDownloadSelectors,
}
export default formSixteenDownloadSlice.reducer
